module.exports = __webpack_public_path__ + "media/images/nereport/icon_nega3-e266e642b351eb987dd5101cd7bdd7ad.svg";